import React from 'react'
import './adminhome.css'
import img2 from '../../assets/1739276909146.jpg'

const AdminHome = () => {
  return (
    <div className='admin_home_container'>
      <div className='admin_home_content'>
        <h1>admin dashboard</h1>
        <h3>content management hub</h3>
        <p>&quot; Where brilliant decisions are made, and occasional 'Oops' moments happen&quot;</p>
        <img src={img2} alt="" />
      </div>
    </div>
  )
}

export default AdminHome